export const organisationConstants = {
  ORGANISATION_INFO_REQUEST: 'ORGANISATION_INFO:REQUEST',
  ORGANISATION_INFO_SUCCESS: 'ORGANISATION_INFO:SUCCESS',
  ORGANISATION_INFO_FAILURE: 'ORGANISATION_INFO:FAILURE',
  ORGANISATION_INFO_CLEAR: 'ORGANISATION_INFO:CLEAR'
};